import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/components/restock-banner/elements/ReStockClientComponent.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.15_@babel+core@7.29.0_@opentelemetry+api@1.9.1_babel-plugin-macros@3.1.0_reac_3f28ddaa1605f4101401bbc5bc6121ac/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.15_@babel+core@7.29.0_@opentelemetry+api@1.9.1_babel-plugin-macros@3.1.0_reac_3f28ddaa1605f4101401bbc5bc6121ac/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/builder/clientUtils.tsx");
